
define('text!components.json',[],function () { return '{\n    "contentManagement": "components/contentManagement/component.js"\n}\n';});

